import ArrayPopup from './ArrayPopup.component';

export default ArrayPopup;
